module.exports = __webpack_public_path__ + "img/turbo-features6.1a8978fe.png";